module.exports = __webpack_public_path__ + "img/img4.3f9826d1.jpg";